import { MapPin, ChevronRight } from 'lucide-react'
import { useNavigate } from 'react-router'

interface Project {
  name: string
  location: string
  type: string
  status: 'Completed' | 'Ongoing'
  url: string
  uuid: string
}

const featuredProjects: Project[] = [
  {
    name: 'The Milton',
    location: 'Apo Legislative Quarters Abuja, Zone E, Abuja',
    type: 'A Premium Development of 4 Units of 5 Bedroom Terrace Duplex with A B.Q',
    status: 'Completed',
    url: '/milton_cover.png',
    uuid: 'irCJAOplGxFeA5ZmzH0S',
  },
  {
    name: 'Walnut Grove',
    location: 'Jahi District, Abuja',
    type: 'A Premium Development 16 Units of 4 Bedroom Semi-Detached Triplex with a BQ.',
    status: 'Completed',
    url: '/walnut_cover.png',
    uuid: 'rh8vPVDk6bTuxFI7hxqz',
  },
  {
    name: 'Manor Grove',
    location: 'Jahi District, Abuja',
    type: 'A Premium Development 10 Units of 4 Bedroom Semi‑Detached Triplex with a BQ',
    status: 'Ongoing',
    url: '/manor_cover.png',
    uuid: 'AhnJIg1kuzPnpY7nyhkR',
  },
]

export default function Features() {
  const navigate = useNavigate()
  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold mb-8">Featured Projects</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {featuredProjects.map((project, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <img
                src={project.url}
                alt={project.name}
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-2">{project.name}</h3>
                <p className="text-gray-600 mb-4">
                  <MapPin className="inline mr-2" size={16} />
                  {project.location}
                </p>
                <p className="text-gray-600 mb-4">{project.type}</p>
                <div className="flex justify-between items-center">
                  <span
                    className={`px-3 py-1 rounded-full text-sm ${
                      project.status === 'Completed'
                        ? 'bg-green-100 text-green-800'
                        : 'bg-orange-100 text-orange-800'
                    }`}
                  >
                    {project.status}
                  </span>
                  <button
                    className="text-primary font-medium hover:text-red-700 flex items-center"
                    onClick={() => navigate(`/projects/${project.uuid}`)}
                  >
                    View Details
                    <ChevronRight size={16} className="ml-1" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
